module.exports = __webpack_public_path__ + "static/media/user.de2ba6b9.png";